/* eslint-disable import/prefer-default-export */
export const MESSAGES_TYPES = {
  ACTION: 'actionMessage',
  EMPTY: 'emptyMessage',
};
